export function mergeMaps<K, V>(
  target: Map<K, V>,
  source: Map<K, V>
): Map<K, V> {
  for (const [key, value] of source) {
    target.set(key, value)
  }
  return target
}

export function prependToMap<K, V>(
  map: Map<K, V>,
  key: K,
  value: V
): Map<K, V> {
  const newMap = new Map<K, V>()
  newMap.set(key, value)

  for (const [k, v] of map) {
    newMap.set(k, v)
  }

  return newMap
}

export function arrayToMap<
  T extends Record<PropertyKey, any>,
  K extends keyof T
>(array: T[], key: K): Map<T[K], T> {
  const map = new Map<T[K], T>()
  for (const item of array) {
    map.set(item[key], item)
  }
  return map
}
